import { whatIfOrDefaultSelector, whatIfInnerSelector } from '../../../WhatIfsSelector';

export const yearOptions = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);

  const whatIfOptions = whatIf.Options || {};

  return [{
    label: 'At Retirement',
    value: 'PurchaseAtRetirement',
  }].concat((whatIfOptions.YearsOptions || []).map(y => ({
    value: y,
    label: y.toString(),
  })));
};

export const yearSelected = (state, props) => {
  if (whatIfInnerSelector(state, props).PurchaseAtRetirement) {
    return 'PurchaseAtRetirement';
  }

  return whatIfInnerSelector(state, props).Year;
};
